import React, { useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// common
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

const MARKETING_TEXT = [
  {
    title: "1. 수집 및 이용 목적",
    contents: [
      {
        num: "0",
        middot: false,
        text: `고객에 대한 편의 제공, 제휴 가맹점의 상품, 서비스 안내 및 이용권유, 사은/판촉행사  등의 마케팅 활동, 시장 조사 및 상품/서비스 개발 연구등을 목적으로 수집 및 이용`,
      },
    ],
  },
  {
    title: "2. 수집 및 이용 항목",
    contents: [
      {
        num: "0",
        middot: true,
        text: `개인 식별 정보 : 성명, 나이, 휴대전화번호, 이메일 등`,
      },
      {
        num: "0",
        middot: true,
        text: `기타 : 아이디, 접속일시, 접속 IP주소 등`,
      },
    ],
  },
  {
    title: "3. 보유기간",
    contents: [
      {
        num: "0",
        middot: false,
        text: `동의일로부터 회원 탈퇴 혹은 마케팅 동의 해제시까지 보유/이용`,
      },
    ],
  },
];

const MarketingPop = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "MARKETING_DETAIL_POP",
      open: { marketingDetailPop: false },
    });
  };

  return (
    <CustomDialog open={state.marketingDetailPop} onClose={handleClose}>
      <PopupHeader title={"마케팅 목적 개인정보 취급방침 "} onClickBack={handleClose} />
      <div className="terms-body">
        <div className="term-text" style={{ marginBottom: 16 }}>
          이용자는 개인(신용) 정보의 선택적인 수집 이용, 제공에 대한 동의를 거부할 수 있습니다.
          다만, 동의하지 않을 경우, 관련 편의 제공(이벤트 안내, 공지사항, 할인행사) 안내 등
          이용목적에 따른 혜택에 제한이 있을 수 있습니다. <br /> 그 밖에 계약과 관련된 불이익은
          없습니다. 동의한 경우에도 이용자는 앱내 설정 메뉴에서, 동의를 철회하거나 마케팅 목적으로
          연락하는 것을 중지하도록 요청할 수 있습니다.
        </div>
        {MARKETING_TEXT.map((v, index) => {
          return (
            <div className="term-wrapper" key={index}>
              <span className="term-title">{v.title}</span>
              {v.contents.map((c, index) => {
                return (
                  <div className="term-content" key={index}>
                    {c.num !== "0" && <span className="term-text number-point">{c.num}.</span>}
                    <span className={`term-text ${c.middot ? " middot" : ""}`}>{c.text}</span>
                  </div>
                );
              })}
            </div>
          );
        })}
        <div className="term-text">더 자세한 사항은 개인정보처리방침을 참고하시기 바랍니다.</div>
      </div>
    </CustomDialog>
  );
};

export default MarketingPop;
